/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/prop-types */
import React from "react";
import { useEffect } from "react";
import { RazorInputProps } from "./types";

// let format = "### #### ### ###";
let evnt: { target: { value: any; name?: string } };

// const formatPhone = (phoneNumber: string, format: string | any[]) => {
//   // Remove all non-digit characters from the phone number
//   const cleaned = phoneNumber.replace(/\D/g, "");

//   let formattedNumber = "";
//   let index = 0;

//   // Loop through the format and replace each '#' with the digits from the cleaned number
//   for (let i = 0; i < format.length; i++) {
//     if (format[i] === "#") {
//       if (index < cleaned.length) {
//         formattedNumber += cleaned[index];
//         index++;
//       } else {
//         break; // Stop if there are no more digits in the cleaned number
//       }
//     } else {
//       formattedNumber += format[i];
//     }
//   }

//   return formattedNumber;
// };

function useFormattedPhoneNumber(): [
  string,
  (event: { target: { value: any } }) => void
] {
  const [phoneNumber, setPhoneNumber] = React.useState("");

  const handlePhoneNumberChange = (event: { target: { value: any } }) => {
    let value = event.target.value;

    evnt = event;

    // Remove any non-digit characters from the input
    value = value.replace(/\D/g, "");

    // Format the phone number based on known patterns
    let formattedNumber = "";

    // Check if the number starts with '2340' and has 15 digits (including the country code)
    if (value.startsWith("2340") && value.length === 14) {
      formattedNumber = formatPhoneNumber(value, "2340");
    } else if (
      value.startsWith("234") &&
      value.slice(0, 4) !== "2340" &&
      value.length === 13
    ) {
      // Check if the number starts with '234' and has 13 digits (including the country code)
      formattedNumber = formatPhoneNumber(value, "234");
    }

    // Check if the number starts with '0' and has 11 digits (excluding the country code)
    else if (value.startsWith("0") && value.length === 11) {
      const networkCode = value.slice(1, 3);
      formattedNumber = formatPhoneNumber(value, networkCode);
    }
    // For other cases, simply display the value as is
    else {
      formattedNumber = value;
    }

    setPhoneNumber(formattedNumber);
  };

  // Function to format the phone number with the network provider based on the network code
  const formatPhoneNumber = (value: string | any, networkCode: string) => {
    let formattedNumber = "";
    if (networkCode === "2340") {
      formattedNumber = `${value.slice(4, 14)} `; // Nigeria
    } else if (networkCode === "234") {
      formattedNumber = `${value.slice(3, 13)} `; // Nigeria
    } else if (networkCode === "70" || networkCode === "80") {
      formattedNumber = `${value.slice(1, 11)} `; // MTN or Airtel
    } else if (networkCode === "81" || networkCode === "82") {
      formattedNumber = `${value.slice(1, 11)} `; // Glo
    } else if (
      networkCode === "90" ||
      networkCode === "91" ||
      networkCode === "92" ||
      networkCode === "93" ||
      networkCode === "94"
    ) {
      formattedNumber = `${value.slice(1, 11)}`; // 9mobile
    } else {
      formattedNumber = value;
    }

    return formattedNumber;
  };

  return [phoneNumber, handlePhoneNumberChange];
}

function PhoneNumberInput({ onChange, ...props }: RazorInputProps) {
  const [phoneNumber, handlePhoneNumberChange] = useFormattedPhoneNumber();
  const [maxLenght, setMaxLenght] = React.useState(10);

  const handleChange = (event: any) => {
    handlePhoneNumberChange(event);
    if (onChange) {
      onChange(event);
    }
  };

  function smartLength(value: string | ((event: any) => void)) {
    if (
      typeof value === "string" &&
      value.startsWith("2340") &&
      value.length > 4
    ) {
      setMaxLenght(15);
    } else if (
      typeof value === "string" &&
      value.startsWith("234") &&
      value.slice(0, 4) !== "2340" &&
      value.length > 4
    ) {
      setMaxLenght(14);
    } else if (
      typeof value === "string" &&
      value.startsWith("0") &&
      value.length > 3
    ) {
      setMaxLenght(11);
    } else {
      setMaxLenght(10);
    }
  }

  useEffect(() => {
    smartLength(phoneNumber);
    onChange &&
      onChange({
        ...evnt,
        target: {
          name: props?.name,
          value: phoneNumber,
        },
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [maxLenght, phoneNumber]);

  // useEffect(() => {
  //   if (props.format) {
  //     format = props.format;
  //   }
  // }, [props?.format]);


  // const numberOfSpaces = format.split(" ").length - 1;

  useEffect(() => {
    if (props?.value) {
      evnt = {
        target: {
          value: props.value,
          name: props?.name,
        },
      };

      handlePhoneNumberChange(evnt);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.value]);

  return (
    <input
      className={props.className}
      type="tel"
      name={props?.name}
      onChange={handleChange}
      maxLength={maxLenght}
      placeholder="Enter phone number"
      {...props}
      value={phoneNumber}
    />
  );
}

export default PhoneNumberInput;
